import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';


export default function DBATypeBasicInfoComponent ({selectedDba,handleInnerFormChange,dbas}: any) {
  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
     
<InputContainer
              label="DBA Name"
              labelField="Text"
              list={dbas}
              onValueChange={(event: any) => {
                  handleInnerFormChange(event.target.value, 'DBATypeId');
                }
              }
              optionName='choose DBA'
              type="select"
              value={selectedDba?.DBATypeId}
              valueField="Value"
            />



  </div>
  }
  expandedPanel="basicInfo"
  headerTitle="Basic Info"
/>


        </>
  )
}